import styled from "styled-components";

const transitionTime = "1s";

const ContainerMetricasHomeSkeleton = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  gap: 16px;

  .metricas-home-skeleton {
    width: 100%;
    border-radius: 24px;
    animation: pulsate ${transitionTime} ease-out infinite alternate;
    animation-delay: calc(var(--i) * 0.1s);

    @keyframes pulsate {
      0% {
        background-color: ${(props) => props.theme.colors.skeleton1};
      }

      100% {
        background-color: ${(props) => props.theme.colors.skeleton2};
      }
    }
  }

  .card-metrica {
    height: 22rem;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    .card-metrica {
      height: 10rem;
    }
  }
`;

export default ContainerMetricasHomeSkeleton;
